import React from "react"
import { PiPrinter } from "react-icons/pi"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./KtOrderCardDropDownPrintButton.module.scss"

const KtOrderCardDropDownPrintButton = props => {
  const { tableOrder } = props

  const [t] = useTranslation()

  const handlePrintOrder = async () => {
    sessionStorage.setItem(
      "data",
      JSON.stringify({
        type: "order",
        value: [tableOrder]
      })
    )

    window.open("/print", "_blank")
  }

  return (
    <button
      className={clsx(classes["dropdownItem"], classes["marginBottom"])}
      onClick={handlePrintOrder}
    >
      <PiPrinter size={16} />
      <span className={classes["dropdownText"]}>
        {t("پرینت")}
      </span>
    </button>
  )
}

export default KtOrderCardDropDownPrintButton